import { track } from '@sloyd/analytics';
import * as api from '@sloyd/api';
import { actions } from '@sloyd/store-base';
import { toast } from '@sloyd/ui';
import { delay, fork, put, takeEvery } from 'saga-ts';
import { invokeEvent, l } from 'shared-base';
import { downloadGlb } from '../utils/glbs';
import { subscriberGuard } from './helpers/guards';

export const saga = {
  id: 'sloyd.text-to-3d',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['TEXT-TO-3D'],
  },
};

type Verb =
  | 'generate' //
  | 'download';

type Action = {
  type: 'TEXT-TO-3D';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  generate: generate,
  download: download,
};

const analyitcsMapTrellis: any = {
  generate: 'Generate Text-to-3D',
  download: 'Text-to-3D Download GLB',
};

export function* download(action: Action) {
  const { payload } = action;

  try {
    const { externalGlb } = payload;
    downloadGlb(externalGlb);
  } catch (err) {}
}

export function* generate(action: Action) {
  const { payload } = action;
  const { prompt, target } = payload;

  try {
    let canPass = yield* subscriberGuard('Subscribe to unlock text-to-3d!');

    if (!canPass) {
      throw new Error('You need to be a subscriber to text-to-3d');
    }

    invokeEvent('nav', { path: '/labs/text-to-3d/progress' });

    yield put(actions.appState.patch({ tsStartExternal: Date.now() }));

    const res = yield api.ai.textTo3d(prompt, target);

    const { isSuccess, data, error = '' } = res;

    if (!isSuccess) {
      toast.error(error);
      track('Image-to-3d Generate Error', { prompt, error });
      throw new Error(`Failed to generate ${error}`);
    } else {
      track('Image-to-3d Generate Success', { prompt });
    }

    yield put(actions.appState.patch({ externalGlb: data }));

    invokeEvent('nav', { path: '/labs/text-to-3d/download' });

    yield put(actions.appState.patch({ tsStartExternal: 0 }));
  } catch (err: any) {
    invokeEvent('sentry', { err });
    yield put(actions.appState.patch({ tsStartExternal: 0 }));
  }
}
export function* textTo3d(action: any) {
  const { verb, id, origin, payload } = action;
  const { source } = payload ?? {};

  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  track(analyitcsMapTrellis[verb], { origin, id, source });

  l(`saga|saga.text-to-3d ${verb} on ${id}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('TEXT-TO-3D', textTo3d);
}
